// 서버 접속 설정.
//  - 명시 서버(우선순위: URL ?server= > 껍데기 주입(SHELL.server) > localStorage rs_server)가 있으면 절대 URL.
//  - 없으면 **same-origin(상대 경로)** — NestJS 가 SPA 를 서빙하면 그대로 동작하고, Vite dev 는 proxy(/api,/ws)로 커버.
import { IS_SHELL, SHELL } from './shell';

const params = new URLSearchParams(location.search);

const explicit = (
  params.get('server') ||
  SHELL.server ||
  localStorage.getItem('rs_server') ||
  ''
).replace(/\/$/, '');
if (params.get('server')) {
  localStorage.setItem('rs_server', explicit);
}

/** REST 기준 URL. '' 이면 same-origin(상대 경로). */
export const SERVER = explicit;

/**
 * 수퍼유저의 조직 문맥 머리(§14.19.1) — 🔴 서버 `ORG_CONTEXT_HEADER` 와 같은 이름(대소문자 무관).
 * su 가 조직을 골라 들어가면 인증 요청(메인 창 `Api` · 세션 `RtcClient`)에 싣는다. su 가 아니면 보내지 않는다(서버도 무시).
 */
export const ORG_CONTEXT_HEADER = 'X-RS-Org';

/** WebSocket 기준 URL. 명시 서버 없으면 현재 호스트 기준. */
export const WS_BASE = explicit
  ? explicit.replace(/^http/, 'ws')
  : `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`;

/**
 * 서버 주소 저장.
 *
 * ⚠️⚠️ **통합앱에서는 `localStorage` 만으로는 아무 효과가 없다.** 껍데기가 주입하는 `SHELL.server` 가
 * 위 우선순위에서 `localStorage` 보다 앞서므로 재기동하면 덮이고, 무엇보다 **피제어 sidecar 에이전트는
 * 웹 뷰어의 저장소를 볼 수 없어** 여전히 옛 주소로 등록을 시도한다(2026-09-08 실사용에서 드러남).
 * ⇒ 껍데기 안에서는 네이티브 `set_server` 로 **껍데기가 소유한 설정**에 저장한다.
 */
export async function setServer(url: string): Promise<void> {
  const clean = url.replace(/\/$/, '');
  localStorage.setItem('rs_server', clean); // 순수 웹(브라우저) 경로
  if (IS_SHELL) {
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke('set_server', { url: clean });
  }
}

// 자동접속/검증용 URL 파라미터(스크린샷·헤드리스 측정과 동일 규약).
// 보안 M2: **자격증명 파라미터(password/sessionpw/anonPassword)는 개발 빌드에서만** URL 로 받는다.
// 프로덕션 빌드(import.meta.env.DEV=false)에선 무시한다 — URL 은 브라우저 히스토리·서버 액세스로그·Referer 로
// 새어나가므로 평문 비밀번호를 쿼리스트링에 담으면 안 된다. 비-비밀 파라미터(code 딥링크 등)는 그대로 둔다.
const allowUrlSecrets = import.meta.env.DEV;
export const AUTO = {
  loginId: params.get('loginId') ?? '',
  password: allowUrlSecrets ? (params.get('password') ?? '') : '',
  code: params.get('code') ?? params.get('agentId') ?? '',
  sessionpw: allowUrlSecrets ? (params.get('sessionpw') ?? '') : '',
  auto: params.get('auto') === '1',
  // 계정 없는 즉석 접속(§17.9.1) 자동 검증: ?anon=1&anonCode=..&anonPassword=..
  anon: params.get('anon') === '1',
  anonCode: params.get('anonCode') ?? '',
  anonPassword: allowUrlSecrets ? (params.get('anonPassword') ?? '') : '',
};
